import React from "react";
import { WhatsApp } from "../icons/whatsapp";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { cn } from "@/lib/utils";

interface WhatsappLinkCompProps {
  position?: "up" | "bottom";
}

const WHATSAPP_LINK = "https://wa.me/2347042438968";

function WhatsappLinkComp({ position = "bottom" }: WhatsappLinkCompProps) {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const positionClass = position === "up" ? "bottom-40" : "bottom-20 md:bottom-6";

  return (
    <div className={cn("fixed right-6 z-[9999] flex items-center justify-center", positionClass)}>
      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-75"></span>

      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="relative flex items-center justify-center rounded-full  shadow-2xl transition-all hover:scale-110 active:scale-95 group"
        aria-label="Join our WhatsApp community"
      >
        <WhatsApp fontSize={isMobile ? 40 : 50} />
      </a>
    </div>
  );
}

export default WhatsappLinkComp;

